import { OrdersFiltersProps } from './orders-filters.types';

export const OrdersFiltersPresets: Partial<OrdersFiltersProps> = {};
